<template>
  <div class="app-page-header flex sm:flex-row justify-between gap-4 mb-6 sm:mb-8">
    <div class="flex-1">
      <slot name="title">
        <h2 class="text-xl sm:text-2xl leading-7 sm:truncate sm:text-3xl sm:tracking-tight">{{ title }}</h2>
      </slot>
    </div>

    <div class="flex-none">
      <slot name="actions">
        <div class="flex flex-col sm:flex-row gap-2">
          <BaseButton v-if="action.to" :to="action.to" variant="accent" class="w-full sm:w-auto">
            {{ action.title }}
          </BaseButton>
          <BaseButton v-if="action.command" variant="accent" class="w-full sm:w-auto" @click="action.command">
            {{ action.title }}
          </BaseButton>
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router'
import BaseButton from '@/components/base/BaseButton.vue'

type Action = {
  title: string
  to?: RouteLocationRaw
  command?: () => void
} 
defineProps({
  title: {
    type: String,
    default: '',
    required: false
  },
  action: {
    type: {} as PropType<Action>,
    default: () => ({}),
    required: false
  }
})
</script>
